<i18n>
  {
    "fr": {
      "title": "Compagnies",
      "all-companies-selected": "Toutes"
    },
    "en": {
      "title": "Airlines",
      "all-companies-selected": "All"
    }
  }
</i18n>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    min-width="360px"
  >
    <template #activator="{on, attrs, value}">
      <v-btn
        v-bind="attrs"
        depressed
        :color="isDefaultValue ? 'white' : 'primaryLight'"
        :class="{'filter-not-default-state': !isDefaultValue}"
        class="pr-2"
        v-on="on"
      >
        {{ $t('title') }}
        <v-icon
          v-if="value === true"
          color="primary"
        >
          mdi-menu-up
        </v-icon>
        <v-icon
          v-else-if="value === false"
          color="primary"
        >
          mdi-menu-down
        </v-icon>
      </v-btn>
    </template>

    <v-card
      flat
    >
      <v-card-title
        class="py-0"
      >
        <v-col>
          {{ $t('title') }}
        </v-col>
        <v-spacer />
        <v-btn
          icon
          @click="menu = false"
        >
          <v-icon color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-checkbox
        v-model="allSelected"
        :indeterminate="indeterminate"
        :label="$t('all-companies-selected')"
        class="pl-4"
      />
      <v-divider />
      <v-card-text
        id="companies-checkbox"
      >
        <template v-for="company in airlineCompanies">
          <v-checkbox
            :key="company.iata"
            v-model="selectedAirlineCompanies"
            :label="company.name"
            :value="company.iata"
            color="primary"
            class="my-0"
          />
        </template>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'

export default {
  name: 'FlightFilterAirlineCompany',
  data: () => ({
    menu: false,
    selected: [],
    allSelected: true,
    indeterminate: false
  }),
  computed: {
    ...mapState({
      selectedAirlineCompaniesState: state => state.fb.searchFilters.selectedAirlineCompanies
    }),
    ...mapGetters({
      airlineCompanies: 'fb/searchFilters/getAirlineCompanies'
    }),
    selectedAirlineCompanies: {
      /**
       * Return vueX store state
       * @return {Object[]}
       */
      get () {
        return this.selectedAirlineCompaniesState
      },
      /**
       * Set a new value to vueX store state
       * @param newVal {Object}
       */
      set (newVal) {
        this.changeSelectedAirlineCompanies(newVal)
      }
    },
    /**
     * Return the selected airline companies array length
     * @return {number}
     */
    selectedAirlineCompaniesLength () {
      return this.selectedAirlineCompanies.length
    },
    /**
     * Return the airline companies length
     * @return {number}
     */
    airlineCompaniesLength () {
      return this.airlineCompanies.length
    },
    /**
     * Return a boolean based on length of selected airline companies and airline companies array
     * This is used for the menu btn coloration
     * @return {boolean}
     */
    isDefaultValue () {
      return this.selectedAirlineCompaniesLength === this.airlineCompaniesLength
    }
  },
  watch: {
    /**
     * Change value of data used by the checkbox with indeterminate state
     * @param newLength {number}
     */
    selectedAirlineCompaniesLength (newLength) {
      if (newLength === this.airlineCompaniesLength) {
        this.allSelected = true
        this.indeterminate = false
      } else if (newLength === 0) {
        this.allSelected = false
        this.indeterminate = false
      } else if (newLength <= this.airlineCompaniesLength) {
        this.allSelected = false
        this.indeterminate = true
      }
    },
    /**
     * change the selected airline company based on the 'all selected' checkbox at the top of the component
     * @param newBool {boolean}
     */
    allSelected (newBool) {
      if (newBool === true) {
        const allAirlineCompaniesValue = []
        this.airlineCompanies.forEach((item) => {
          allAirlineCompaniesValue.push(item.iata)
        })
        this.changeSelectedAirlineCompanies(allAirlineCompaniesValue)
      } else if (newBool === false && this.selectedAirlineCompaniesLength === this.airlineCompaniesLength) {
        this.changeSelectedAirlineCompanies([])
      }
    }
  },
  methods: {
    ...mapMutations({
      changeSelectedAirlineCompanies: 'fb/searchFilters/setSelectedAirlineCompanies'
    })
  }
}
</script>

<style scoped>
  #companies-checkbox {
    max-height: 300px;
    overflow-y: auto;
  }

  .filter-not-default-state {
    color: #003d58;
  }
</style>
